import type { TFunction } from 'i18next';

import type { Reply } from '@hotjar/comments/domains/model';
import hotjarAvatarImage from '@hotjar/webapp/images/hotjar-avatar.png';

export const getAutoCreatedComment = (t: TFunction, createdAt?: Date): Reply => {
  return {
    id: 0,
    threadId: 0,
    createdEpochTime: (createdAt ?? new Date()).valueOf() / 1000,
    author: { name: 'Hotjar', email: '', avatar: hotjarAvatarImage, id: 0 },
    content: [
      {
        type: 'text',
        value: t('highlights:single.auto_created'),
      },
    ],
  };
};
